var React = require('react');

function Roundlinkedin (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18","r":"17.5","stroke":"#EEEEEE","strokeOpacity":"0.5","key":0}),React.createElement("path",{"d":"M12.5305 14.268C13.4864 14.268 14.2612 13.4918 14.2612 12.5344C14.2612 11.5769 13.4864 10.8008 12.5305 10.8008C11.5747 10.8008 10.7998 11.5769 10.7998 12.5344C10.7998 13.4918 11.5747 14.268 12.5305 14.268Z","fill":"#EEEEEE","key":1}),React.createElement("path",{"d":"M15.8953 15.582V25.2H18.8765V20.4437C18.8765 19.1886 19.1123 17.9732 20.6658 17.9732C22.198 17.9732 22.2169 19.4081 22.2169 20.5229V25.2008H25.1998V19.9263C25.1998 17.3354 24.6429 15.3443 21.6197 15.3443C20.1683 15.3443 19.1953 16.1421 18.7975 16.8972H18.7571V15.582H15.8953ZM11.037 15.582H14.023V25.2H11.037V15.582Z","fill":"#EEEEEE","key":2})]);
}

Roundlinkedin.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Roundlinkedin;

Roundlinkedin.default = Roundlinkedin;
